import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem("vortex_cart") || "[]");
      return saved.map((i) => ({
        ...i,
        key: i.key || i.id + "::" + (i.color || ""),
      }));
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("vortex_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (product, qty = 1, color = "") => {
    const key = product.id + "::" + (color || "");
    setItems((prev) => {
      const found = prev.find((i) => i.key === key);
      if (found) {
        return prev.map((i) =>
          i.key === key ? { ...i, qty: Math.min(i.qty + qty, 10) } : i
        );
      }
      return [...prev, { key, id: product.id, qty, color, product }];
    });
    setOpen(true);
  };

  const removeItem = (key) => setItems((prev) => prev.filter((i) => i.key !== key));
  const setQty = (key, qty) =>
    setItems((prev) =>
      qty <= 0
        ? prev.filter((i) => i.key !== key)
        : prev.map((i) => (i.key === key ? { ...i, qty: Math.min(qty, 10) } : i))
    );
  const clear = () => setItems([]);

  const { count, total } = useMemo(
    () => ({
      count: items.reduce((s, i) => s + i.qty, 0),
      total: items.reduce((s, i) => s + i.qty * (i.product?.price || 0), 0),
    }),
    [items]
  );

  return (
    <CartContext.Provider
      value={{ items, open, setOpen, addItem, removeItem, setQty, clear, count, total }}
    >
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
